import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import { Row, Col } from 'react-bootstrap';

export default class Footer extends Component {
  static propTypes = {
    indexUrl: PropTypes.string.isRequired,
  };

  render() {
    const { indexUrl } = this.props;

    return (
      <footer>
        <div className="container">
          <Row>
            <Col xs={12} md={6}>
              <div className="logos">
                {window.cviConfig.cviCountry !== 'Belgium' && (
                  <Link to={indexUrl}>
                    <div className={`logo-voltiz logo-voltiz-${window.cviConfig.cviCountry}`} />
                  </Link>
                )}
                {/* <a href={window.cviConfig.cviUrl} target="_blank">
                  {window.cviConfig.cviCountry !== 'Belgium' ? (
                    <div className={`logo-cvi logo-cvi-${window.cviConfig.cviCountry}`} />
                  ) : (
                    <div className={`logo-${window.cviConfig.cviCity}`}/>
                  )}
                </a> */}
                <a href="http://thinkcreatix.com" target="_blank">
                  <div className="logo-gohealth" />
                </a>
              </div>
            </Col>
            <Col xs={12} md={6}>
              <div className="copy">
                © 2019 Copyright by CVISlovakia. Created by{' '}
                <a href="http://www.thinkcreatix.com/" target="_blank">
                  Creatix Inc.
                </a>
              </div>
            </Col>
          </Row>
        </div>
      </footer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/footer/Footer.js